import { InjectionToken } from '@angular/core';
import { SubmissionAdminState } from '../types/submission-admin.types';

/**
 * Initial state for submission admin
 */
export const SUBMISSION_ADMIN_INITIAL_STATE: SubmissionAdminState = {
  workspaceSubTypes: [],
  totalWorkspaceSubTypes: 0,
  selectedWorkspaceSubType: null,
  currentFilters: {
    page: 1,
    page_size: 10,
    filters: [],
    query: '',  
  },
  isLoading: false,
  error: null,
  irisRoutingGroupData: {
    data: [],
    total: 0
  },
  shortNames: [], 
};

/**
 * Injection token for submission admin initial state
 */
export const SUBMISSION_ADMIN_INITIAL_STATE_TOKEN =
  new InjectionToken<SubmissionAdminState>('SUBMISSION_ADMIN_INITIAL_STATE', {
    providedIn: 'root',
    factory: () => SUBMISSION_ADMIN_INITIAL_STATE,
  });
